import { LoanStatus, LoanStatusExternal, ProductExternal } from '@nemuru-eng/js-api-client';

export class LoanStatusExternalMap {
  public static fromProductExternal(productExternal: ProductExternal): LoanStatusExternal[] {
    if ([ProductExternal.BNPL, ProductExternal.PAY_BY_LINK].includes(productExternal)) {
      return [
        LoanStatusExternal.INITIAL,
        LoanStatusExternal.ON_HOLD,
        LoanStatusExternal.REQUESTED,
        LoanStatusExternal.CONFIRMED,
      ];
    }
    return [
      LoanStatusExternal.INITIAL,
      LoanStatusExternal.ON_HOLD,
      LoanStatusExternal.APPROVED,
      LoanStatusExternal.CONFIRMED,
    ];
  }

  public static fromLoanStatus(loanStatus: LoanStatus): LoanStatusExternal {
    switch (loanStatus) {
      case LoanStatus.STATUS_INITIAL:
        return LoanStatusExternal.INITIAL;
      case LoanStatus.STATUS_ANALYSING:
        return LoanStatusExternal.ON_HOLD;
      case LoanStatus.STATUS_DENIED:
        return LoanStatusExternal.DENIED;
      case LoanStatus.STATUS_LENDER_HAS_BEEN_SELECTED:
      case LoanStatus.STATUS_CONTRACT_SIGNED:
        return LoanStatusExternal.APPROVED;
      case LoanStatus.STATUS_DOCS_APPROVED:
        return LoanStatusExternal.CONFIRMED;
      case LoanStatus.STATUS_ACTIVE_TRIAL:
      case LoanStatus.STATUS_ACTIVE:
      case LoanStatus.STATUS_UNPAID:
      case LoanStatus.STATUS_ENDED:
        return LoanStatusExternal.PAID;
      case LoanStatus.STATUS_EXPIRED:
        return LoanStatusExternal.EXPIRED;
      case LoanStatus.STATUS_CANCELLED:
      case LoanStatus.STATUS_CANCELLED_TEST:
        return LoanStatusExternal.CANCELLED;
      case LoanStatus.STATUS_DESISTED:
        return LoanStatusExternal.DESISTED;
      default:
        throw new Error(`Unknown loan status: ${loanStatus}`);
    }
  }
}
